<div class="container">
  <!-- section title -->
  <h2 class="section-title wow fadeInUp">Clients & Reviews</h2>

  <div class="spacer-60"></div>

  <!-- testimonials wrapper -->
  <div class="testimonials-wrapper">
    <ngb-carousel *ngIf="images" [interval]="5000" [showNavigationArrows]="false">
      <ng-template ngbSlide>
        <div class="testimonial-item text-center mx-auto">
          <div class="thumb mb-3 mx-auto">
            <img src="assets/images/avatar-1.svg" alt="customer-name" />
          </div>
          <h4 class="mt-3 mb-0">Shamraiz Ali</h4>
          <span class="subtitle">CEO of ZM</span>
          <div class="bg-white padding-30 shadow-dark rounded triangle-top position-relative mt-4">
            <p class="mb-0">
              I enjoy working with them and learn so much. You guys make the process fun and interesting. Good luck! 👍
            </p>
          </div>
        </div>
      </ng-template>

      <ng-template ngbSlide>
        <div class="testimonial-item text-center mx-auto">
          <div class="thumb mb-3 mx-auto">
            <img src="assets/images/avatar-2.svg" alt="customer-name" />
          </div>
          <h4 class="mt-3 mb-0">Eng Waqas ur Rehman </h4>
          <span class="subtitle">Ceo of Tierays</span>
          <div class="bg-white padding-30 shadow-dark rounded triangle-top position-relative mt-4">
            <p class="mb-0">
              Excellent work! The team's dedication and creativity exceeded our expectations. Highly recommended! 👏
            </p>
          </div>
        </div>
      </ng-template>


      <ng-template ngbSlide>
        <div class="testimonial-item text-center mx-auto">
          <div class="thumb mb-3 mx-auto">
            <img src="assets/images/avatar-3.svg" alt="customer-name" />
          </div>
          <h4 class="mt-3 mb-0">Adnan Satti</h4>
          <span class="subtitle">Marketing Manager</span>
          <div class="bg-white padding-30 shadow-dark rounded triangle-top position-relative mt-4">
            <p class="mb-0">
              The collaboration was seamless, and the end result exceeded our expectations. Looking forward to future projects! 👍
            </p>
          </div>
        </div>
      </ng-template>

      <ng-template ngbSlide>
        <div class="testimonial-item text-center mx-auto">
          <div class="thumb mb-3 mx-auto">
            <img src="assets/images/avatar-3.svg" alt="customer-name" />
          </div>
          <h4 class="mt-3 mb-0">Emily Brown</h4>
          <span class="subtitle">CEO at ECU</span>
          <div class="bg-white padding-30 shadow-dark rounded triangle-top position-relative mt-4">
            <p class="mb-0">
              Working with this team was a pleasure. Their attention to detail and commitment to quality are commendable. 👌
            </p>
          </div>
        </div>
      </ng-template>
    </ngb-carousel>
  </div>
</div>
